<div
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1200;"
  aria-live="polite"
  aria-atomic="true"
>
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="toast show align-items-center border-0 fm-toast"
      [class]="'fm-toast-' + toast.type"
      role="alert"
    >
      <div class="d-flex">
        <div class="toast-body">
          <strong class="d-block fm-toast-header">
            @if (toast.type === 'success') { <i class="bi bi-check-circle-fill me-1"></i> }
            @if (toast.type === 'error') { <i class="bi bi-x-circle-fill me-1"></i> }
            @if (toast.type === 'warning') { <i class="bi bi-exclamation-triangle-fill me-1"></i> }
            @if (toast.type === 'info') { <i class="bi bi-info-circle-fill me-1"></i> }
            {{ toast.header }}
          </strong>
          <span class="small">{{ toast.body }}</span>
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          (click)="toastService.remove(toast)"
        ></button>
      </div>
    </div>
  }
</div>
